import { Card } from '@cmsgov/ds-medicare-gov'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { DataCardItem } from './DataCardItem'

import classes from './DrugCard.module.css'

type PendingDrugCardProps = {
  isLoading: true
}

type LoadedDrugCardProps = {
  isLoading: false
  name: string
  groupNumber: string
  bin: string
  id: string
  pcn: string
  startDate: string
}

type DrugCardProps = PendingDrugCardProps | LoadedDrugCardProps

export function DrugCard (props: DrugCardProps) {
  const { t } = useTranslation('rxDrugCard', { keyPrefix: 'card' })

  const formattedStartDate =
    !props.isLoading && props.startDate
      ? new Intl.DateTimeFormat('en-US').format(new Date(props.startDate))
      : ''

  return (
    <Card className={cx('ds-u-padding--3', classes.container)}>
      <div className={classes.grid}>
        {props.isLoading
          ? (
          <>
            <DataCardItem heading={t('plan')} isLoading={true} />

            <DataCardItem heading={t('group')} isLoading={true} />

            <DataCardItem heading={t('bin')} isLoading={true} />

            <DataCardItem heading={t('id')} isLoading={true} />

            <DataCardItem heading={t('pcn')} isLoading={true} />
          </>
            )
          : (
          <>
            <DataCardItem
              heading={t('plan')}
              value={props.name}
              isLoading={false}
            />

            <DataCardItem
              heading={t('group')}
              value={props.groupNumber}
              isLoading={false}
            />

            <DataCardItem
              heading={t('bin')}
              value={props.bin}
              isLoading={false}
            />

            <DataCardItem
              heading={t('id')}
              value={props.id}
              isLoading={false}
            />

            <DataCardItem
              heading={t('pcn')}
              value={props.pcn}
              isLoading={false}
            />

            <DataCardItem
              heading={t('startDate')}
              value={formattedStartDate}
              isLoading={false}
            />
          </>
            )}
      </div>
    </Card>
  )
}

export default DrugCard
